import React from 'react';
import PropTypes from 'prop-types';
import { miscEventFaqDefinitions, category_labels } from '../data/eventFaqDefinition';
import { ReadMoreText } from '../../elements-container/read-more-text-toggle';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Lunch } from '../../icons';
import CollapsingDescription from '../../elements-description/CollapsingDescription';

const FoodBeverageExpanded = ({ foodAndBeverage, foodPrepRules, intl }) => {
  const label = <FormattedMessage
    id={category_labels.food_and_beverage.id}
    defaultMessage={category_labels.food_and_beverage.defaultMessage}
  />;
  return (<div className="EventFAQ">
    <div className="flex middle">
      <Lunch height={24} width={24} className="margin-sm-right" />
      <div className="h6 margin-md-left padding-xs-top padding-xs-bottom faq-section">{label}</div>
    </div>
    <div className="event-faq-section padding-md-bottom">
      { foodAndBeverage &&
          <div className="margin-lg-bottom section-indent">
            <div className="faq-label heavier">
              {intl.formatMessage(miscEventFaqDefinitions.food_rules)}
            </div>
            <div className="margin-lg-bottom">
              <CollapsingDescription description={foodAndBeverage} />
            </div>
            {foodPrepRules && <hr />}
          </div>
      }
      {
        foodPrepRules &&
          <div className="margin-lg-bottom section-indent">
            <div className="faq-label heavier">
              {intl.formatMessage(miscEventFaqDefinitions.food_prep_rules)}
            </div>
            <div className="text-gray-900 description margin-lg-bottom">
              <CollapsingDescription description={foodPrepRules} />
            </div>
          </div>
      }
    </div>
  </div>);
};

FoodBeverageExpanded.propTypes = {
  foodAndBeverage: PropTypes.string,
  foodPrepRules: PropTypes.string,
  intl: PropTypes.object
};

export default injectIntl(FoodBeverageExpanded);
